import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Container,
  FormControl,
  Autocomplete,
} from '@mui/material';
import * as Yup from 'yup';
import './styles.css';

import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import DialogMain from '../../components/Dialogs/dialogMain';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';

import AutocompleteParameters from '../../components/AutocompleteParameters';

import HandleSamples from '../../components/handleParameters';

function TestLot() {
  const location = useLocation();

  const [selectedLot, handleLot] = useState(null);
  const [selectedForm, handleForm] = useState('');
  const [lots, setLots] = useState([]);

  const [parameters, setParameters] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [samples, setSamples] = useState([]);
  const [forms, setForms] = useState([]);

  const [openParameter, setOpenParameter] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const parametersIsNull = useState(false);

  const classes = useStyles();
  const history = useHistory();
  let { id } = useParams();
  const dispatch = useDispatch();
  const [selectedDate, handleDateChange] = useState(new Date());
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();

  useEffect(() => {
    if (location.state !== undefined) {
      id = location.state.id;
    }
  }, [location]);

  function updateSamples(options) {
    formik.setFieldValue('parameters', options);
  }

  useEffect(() => {
    async function load() {
      // carrega os dados nos seus devidos campos caso tenha id, do contrário,
      // carrega o formulário vazio para cadastrar um novo
      setOpenProgress(true);

      const lot_ = await api.get('/lots');
      const form_ = await api.get('/forms');
      const parameters_ = await api.get('/parameters');
      // var workers_ = await api.get("/workers")

      if (form_.data.length === 0) {
        setOpenForm(true);
      }

      setLots(lot_.data);
      setForms(form_.data);
      setParameters(
        parameters_.data.map((parameter) => ({
          ...parameter,
          parameter_id: parameter.id,
        })),
      );

      setOpenProgress(false);

      if (id) {
        const test_lots_ = await api.get(`/test-lots/${id}`);
        formik.setValues(test_lots_.data);

        handleLot(test_lots_.data.lot);

        handleForm(parseInt(test_lots_.data.form));

        setSelectedParameters(
          test_lots_.data.parameters.map((value) => ({
            ...value.parameter,
            test_lot_id: value.test_lot_id,
          })),
        );
        const parametersFormateds = test_lots_.data.parameters;

        setSamples(parametersFormateds);
        formik.setFieldValue('parameters', parametersFormateds);

        if (location.state !== undefined) {
          id = null;
          formik.setFieldValue('id', null);
        } else {
          handleDateChange(new Date(test_lots_.data.date));
        }
      }
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/test-lots/${id}`, { ...data })
        : await api.post('/test-lots', { ...data });
      success();
      history.push('/test-lots');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      observation: '',
      lot: '',
      get_at: '',
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(setLoading(true));
      alert(selectedDate);
      values.date = selectedDate;
      values.lot = selectedLot.id;
      values.form = selectedForm ? selectedForm.id : null;

      request(values);
    },
  });

  function handleParameters(parameters) {
    setSelectedParameters(parameters);
  }

  useEffect(() => {
    if (selectedParameters && !id) {
      setSamples(selectedParameters);
      formik.setFieldValue('parameters', selectedParameters);
    }
  }, [selectedParameters]);

  useEffect(() => {
    // Carrega os dados na tabela de cadastro
    if (selectedForm) {
      if (selectedForm.parameters !== undefined) {
        const parametersFormateds = selectedForm.parameters.map(
          (parameter) => ({
            ...parameter.parameter,
            id: parameter.parameter_id,
            parameter_id: parameter.parameter_id,
          }),
        );
        setSelectedParameters(parametersFormateds);

        setSamples(parametersFormateds);
        formik.setFieldValue('parameters', parametersFormateds);
        // setar imagens
      }
    }
  }, [selectedForm, id]);

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      {' '}
      {/** Carregamento circular para o carregamento dos dados */}
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.root}>
          <h2 className="title">Dados do Teste de Qualidade da Larva</h2>

          {/** *
           * Diálogos para facilitar cadastro.
           */}

          {openParameter ? (
            <DialogMain
              message="A propridade não possui nenhum parâmetro cadastrado. Por favor, cadastre um parâmetro para prosseguir."
              route="/parameter"
            />
          ) : null}

          {openForm ? (
            <DialogMain
              message="Não há nenhum formulário cadastrado. Por favor, cadastre um formulário para prosseguir."
              route="/form"
            />
          ) : null}

          <FormGroup>
            <Autocomplete
              noOptionsText="Sem opções"
              name="lot_id"
              options={lots}
              value={selectedLot}
              getOptionLabel={(options) => options.code}
              onChange={(p, v) => {
                handleLot(v);
              }}
              onBlur={formik.handleBlur}
              renderInput={(params) => (
                <TextField {...params} label="Lote" variant="outlined" />
              )}
            />
          </FormGroup>
          <FormGroup>
            <LocalizationProvider
              adapterLocale={deLocale}
              dateAdapter={DateFnsUtils}
            >
              <DatePicker
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                label={<div>Data</div>}
                name="get_at"
                variant="inline"
                inputVariant="outlined"
                invalidDateMessage="Data Inválida"
                value={selectedDate}
                onChange={(get_at) => handleDateChange(get_at)}
                onBlur={formik.handleBlur}
                format="dd/MM/yyyy"
                error={!!(formik.touched.get_at && formik.errors.get_at)}
                helperText={
                  formik.touched.get_at
                  && formik.errors.get_at
                  && formik.errors.get_at
                }
                // inputFormat="DD/MM/YYYY"
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </FormGroup>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="observation"
              label={<div>Observação (Opcional)</div>}
              variant="outlined"
              name="observation"
              type="text"
              value={formik.values.observation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                !!(formik.touched.observation && formik.errors.observation)
              }
              helperText={
                formik.touched.observation
                && formik.errors.observation
                && formik.errors.observation
              }
            />
          </FormGroup>

          {!id && (
            <AutocompleteParameters
              form_id={null}
              parameters={selectedParameters}
              options={parameters}
              callback={handleParameters}
              parametersIsNull={parametersIsNull}
            />
          )}
          {!id && (
            <FormGroup>
              <Autocomplete
                noOptionsText="Sem opções"
                name="form"
                options={forms}
                value={selectedForm}
                getOptionLabel={(options) => (typeof options === 'string' ? options : options.name)}
                onChange={(p, v) => {
                  handleForm(v);
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Formulário"
                    variant="outlined"
                  />
                )}
              />
            </FormGroup>
          )}
          <h3 className="titleb">Parâmetros</h3>
          <FormGroup>
            <FormControl>
              <HandleSamples
                label="Valor"
                parameters={samples}
                samples={samples}
                callback={updateSamples}
              >
                {' '}
              </HandleSamples>
            </FormControl>
          </FormGroup>
        </div>
        <GroupButton
          deleteRoute="/test-lots/"
          routeDelete="/test-lots"
          returnRoute="/test-lots"
          id={id}
          disable={disable}
          message="A exclusão dessa biometria pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default TestLot;
